import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import permissions from "app/permissions";
import { MobileListRow } from "features/MobileListRow";
import {
  Datagrid,
  DateField,
  FunctionField,
  List,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ShowButton,
  SimpleList,
  TextField,
} from "react-admin";

import SecuredComponent from "server/security/SecuredComponent";
import { ErasmusApplicationStatuses, MOBILE_BREAKPOINT } from "utils/constants";

import ChangeErasmusStatusesModal from "../Partials/ChangeErasmusStatusesModal";
import { erasmusRequests } from "api/erasmusApi";

const listFilters = [
  <ReferenceInput
    source="status"
    reference={erasmusRequests.getApplicationStatusesSelect()}
    alwaysOn
  >
    <SelectInput
      label="Статус"
      optionText="nameBg"
      style={{ width: 300 }}
    />
  </ReferenceInput>,
];

const ListOutgoingApplicationsStudents = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Списък заминаващи за обучение"
      filters={listFilters}
      sx={settings.style.blockStyle}
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Имена",
                    value: (
                      <>
                        {record?.firstName} {record?.lastName}
                      </>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  { label: "Кампания", value: record?.campaignName },
                  {
                    label: "Статус",
                    value: (
                      <ReferenceField
                        label="Статус"
                        source="status"
                        reference={erasmusRequests.getApplicationStatusesSelect()}
                        sortable={false}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Тип мобилност",
                    value: (
                      <ReferenceField
                        label="Тип мобилност"
                        source="type"
                        reference={erasmusRequests.getMobilityTypesSelect()}
                        sortable={false}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                  {
                    label: "Период",
                    value: (
                      <>
                        <DateField
                          source="mobilityStartDate"
                          locales="bg-BG"
                          emptyText="-"
                        />
                        {" - "}
                        <DateField
                          source="mobilityEndDate"
                          locales="bg-BG"
                          emptyText="-"
                        />
                      </>
                    ),
                  },
                ]}
              />
            </div>
          )}
          secondaryText={record => (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
              {record.status !== ErasmusApplicationStatuses.Closed ? (
                <SecuredComponent permission={permissions.canManageOutgoingStudentsRector}>
                  <ChangeErasmusStatusesModal record={record} />
                </SecuredComponent>
              ) : null}
            </div>
          )}
          tertiaryText={() => <ShowButton label="" />}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            label="Име"
            source="firstName"
            sortable={false}
          />

          <TextField
            label="Фамилия"
            source="lastName"
            sortable={false}
          />
          <TextField
            label="Кампания"
            source="campaignName"
            sortable={false}
          />
          <ReferenceField
            label="Тип мобилност"
            source="type"
            reference={erasmusRequests.getMobilityTypesSelect()}
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <DateField
            label="Начало на мобилността"
            source="mobilityStartDate"
            locales="bg-BG"
            sortable={false}
            emptyText="-"
          />
          <DateField
            label="Край на мобилността"
            source="mobilityEndDate"
            locales="bg-BG"
            sortable={false}
            emptyText="-"
          />
          <ReferenceField
            label="Статус"
            source="status"
            reference={erasmusRequests.getApplicationStatusesSelect()}
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <FunctionField
            render={rec =>
              rec.status !== ErasmusApplicationStatuses.Closed ? (
                <SecuredComponent permission={permissions.canManageOutgoingStudentsRector}>
                  <ChangeErasmusStatusesModal record={rec} />
                </SecuredComponent>
              ) : null
            }
          />

          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};

export default ListOutgoingApplicationsStudents;
